import { ShieldCheck, Car, Wrench, FileCheck, Battery, CircleDot } from "lucide-react";
import { Link } from "react-router-dom";

const CATEGORIES = [
  { icon: Wrench, title: "Engine", desc: "Compression, idle, leaks, cooling, belts and oil condition." },
  { icon: Car, title: "Transmission", desc: "Smooth shifting, clutch behaviour (MT), gear noise, oil." },
  { icon: Car, title: "Exterior", desc: "Paint, panel alignment, dents, chassis integrity, glass." },
  { icon: Car, title: "Interior", desc: "Upholstery, dashboard, roof lining, cabin smell and wear." },
  { icon: Battery, title: "Electrical", desc: "Battery, lights, indicators, infotainment, AC, sensors." },
  { icon: CircleDot, title: "Tyres & Brakes", desc: "Tread depth, uneven wear, pad life, rotor condition." },
  { icon: FileCheck, title: "Documentation", desc: "RC, insurance, PUC, NOC where applicable, hypothecation." },
  { icon: ShieldCheck, title: "Ownership", desc: "Verified ownership chain, previous owners, fleet usage." },
];

export default function CertifiedPage() {
  return (
    <div data-testid="certified-page">
      <section className="bg-[#111] text-white py-14">
        <div className="cs-container">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white/70 bg-white/10 border border-white/15 rounded-full px-3 py-1"><ShieldCheck size={12} /> Our standard</span>
          <h1 className="mt-5 font-display font-extrabold text-4xl sm:text-5xl">The CS Certified Promise</h1>
          <p className="mt-4 text-white/80 max-w-2xl">
            Every car with the CS Certified badge has been personally inspected by our team across these core categories. We only certify cars we would buy ourselves.
          </p>
          <Link to="/buy?certified=true" className="btn-primary mt-6">See CS Certified Cars →</Link>
        </div>
      </section>
      <section className="cs-container py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CATEGORIES.map((c, i) => (
            <div key={i} className="rounded-xl border border-gray-200 p-5">
              <c.icon className="text-[#940C2C]" size={22} />
              <div className="mt-3 font-display font-bold">{c.title}</div>
              <p className="mt-1 text-sm text-gray-500 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
        <p className="mt-8 text-xs text-gray-500">The specific inspection notes for each certified car are shown on that car's detail page under the Inspection section.</p>
      </section>
    </div>
  );
}
